import { render, staticRenderFns } from "./daily-tranx.vue?vue&type=template&id=741ad253"
import script from "./daily-tranx.vue?vue&type=script&lang=js"
export * from "./daily-tranx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports